var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 600 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#002b7f",
    width: 600,
    height: 300
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#ffc61e",
    y: 137.5,
    width: 600,
    height: 25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M 150,262.5 L 143.5295,236.6481 L 125,255.8012 L 132.3223,230.1777 L 106.6987,237.5 L 125.8519,218.9705 L 100,212.5 L 125.8519,206.0295 L 106.6987,187.5 L 132.3223,194.8223 L 125,169.1988 L 143.5295,188.3519 L 150,162.5 L 156.4705,188.3519 L 175,169.1988 L 167.6777,194.8223 L 193.3013,187.5 L 174.1481,206.0295 L 200,212.5 L 174.1481,218.9705 L 193.3013,237.5 L 167.6777,230.1777 L 175,255.8012 L 156.4705,236.6481 L 150,262.5 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNr);
export default __webpack_public_path__ + "static/media/nr.70356aeaffd17f715573c3986adf3263.svg";
export { ForwardRef as ReactComponent };